import { Component, OnInit,  ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { ActivatedRoute, Router, NavigationEnd, Event as NavigationEvent } from '@angular/router';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { HaloLoaderService } from '../../../core/halo-loader/halo-loader.service';
import { MemberFirebaseTokenService, IToken } from '../../services/member-firebase-token.service';
import {tab, TRAININGDATA } from '../training-data';
import { environment } from '../../../../environments/environment';
import { SafeUrl } from '@angular/platform-browser';
import { CommonUtil } from '../../../core/Utils/common-util';

@Component({
  selector: 'app-challenges',
  templateUrl: './challenges.component.html',
  styleUrls: ['./challenges.component.scss']
})
export class ChallengesComponent implements OnInit {

 // subscriptions
 private _facilityOnChange: Subscription;
 private _tabOnChange: Subscription;

 rootScopeData: RootScopeDeclare;
 currentFacility: FacilityObject;
 memberToken: string;
 membrBasePath: string;
 memberSubPath: SafeUrl|null = '';
 currentPath:string = 'dashboard';
 currentTabDetails:tab[] =[{page:'', key:'', url:''}];
 showIframeLoader:boolean = true;

 constructor(private rootScopeService: RootScopeService,
   private _facilityService: FacilityService,
   private _router: Router,
   private _getMemberToken: MemberFirebaseTokenService,
   private loader: HaloLoaderService,
   private _commonUtil: CommonUtil) { }

 getRootScopeData(): void {
   this.rootScopeService.getRootScope().subscribe(rootScopeData => {
     this.rootScopeData = rootScopeData;
   });
 }

 setTabDetails(name: string): void {
  this.rootScopeData.pageName = 'Member - ' + name ;
   this.currentTabDetails = TRAININGDATA.filter(u => 
     u.page == name);
 }

 ngOnInit(): void {
   this.getRootScopeData();
   this.membrBasePath = environment.membrHostPath; 

   // subscript facility change / when facility change
   this.currentFacility = this._facilityService.selectedFacility();
   this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
     this.currentFacility = res;
     this.fetchMemberData();
   });

   let path = this._router.url.split("/");
   this.currentPath = path[path.length-1];    
   this.setTabDetails(this.currentPath);

   this._tabOnChange = this._router.events.subscribe(
     (event: NavigationEvent): void => {
       if (event instanceof NavigationEnd) {
         let path = this._router.url.split("/");
         this.currentPath = path[path.length-1];         
         this.setTabDetails(this.currentPath);
         this.fetchMemberData();  
       }
     }
   );

   this.fetchMemberData();
 }

 ngOnDestroy() {
   // destroy subscriber
   if (this._facilityOnChange) {
     this._facilityOnChange.unsubscribe();
   }
   this._tabOnChange.unsubscribe();
 }

 fetchMemberData(){
   if ((this.currentFacility.summary && this.currentFacility.summary.facilityRights.trainingMenu != 'true') ||
   (this.currentFacility.summary && this.currentFacility.summary.facilityRights.trainingClasses == 'false') ||
   (this.currentFacility.summary && this.currentFacility.summary.facilityRights.trainingPrograms == 'false' && (this.currentPath.indexOf('dashboard')>-1 || this.currentPath.indexOf('training')>-1))) {
     this._commonUtil.redirectToAvailablePage();
   }
   this.getToken();
 }

 getToken(){    
   this.loader.startProcess();
     this._getMemberToken
       .get()
       .subscribe(
         (data: IToken) => {
           this.loader.endProcess();
           this.memberToken=data.jwtToken;

           if(this.memberSubPath && this.memberSubPath.toString().indexOf('membraws')>-1)
            this.memberSubPath=this.memberSubPath+"&facilityId="+this.currentFacility.facilityId+"&locale="+this.rootScopeData.currentUser.preferredLanguage;
           else
             this.memberSubPath = this.membrBasePath + this.memberToken + this.currentTabDetails[0].url+"&facilityId="+this.currentFacility.facilityId+"&locale="+this.rootScopeData.currentUser.preferredLanguage;
           
         },
         error => {
           console.error('API failed.');
           this.loader.endProcess();
         }
       );
 }

 showLoadSpinner(){
   this.showIframeLoader =true;
 }

 hideLoadSpinner(){
   this.showIframeLoader =false;
 }
}
